import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  props: {},
})

export default class BetterNetworksCoZaHome extends Vue {
}
